import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { keyframes } from 'styled-components';
import { Section } from '../Styled';

export const SliderSection = styled(Section)`
  max-width: 100vw;
  width: 100vw;
  padding: 0 0 35px;
`;

export const SliderWrap = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const openCard = keyframes`
0% {transform: translateY(-100%);
    opacity: 0; max-height: 0px;}
100% {transform: translateY(0);
    opacity: .8; max-height: 400px;}`;

const closeCard = keyframes`
0% {
    opacity: .8; max-height: 400px}
100% {opacity: 0; max-height: 0px}`;

export const SliderSelf = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  justify-content: flex-start;
  padding: 35px 0 0;
  padding-left: 30%;
  column-gap: 25px;
  overflow: visible;
  height: 375px;
  transition: all 250ms ease-out;
  @media screen and (max-width: 1000px) {
    padding-left: 27.5%;
  }
  @media screen and (max-width: 768px) {
    padding-left: 22.5%;
  }
  @media screen and (max-width: 550px) {
    padding-left: 17%;
  }
  @media screen and (max-width: 450px) {
    padding-left: 10%;
  }
  @media screen and (max-width: 400px) {
    padding-left: 0;
  }
`;

export const InvisibleBox = styled.div`
  flex-grow: 1;
  flex-basis: auto;
`;

export const SliderTitelCon = styled.div`
  display: flex;
  margin: 0;
  flex-direction: column;
  align-items: flex-start;
  column-gap: 25px;
  row-gap: 5px;
  position: relative;
  z-index: 3;
`;

export const SliderKort = styled.div`
  min-width: 250px;
  max-width: 250px;
  height: max-content;
  flex-grow: 0;
  flex-srink: 0;
  padding: 15px 25px;
  margin: 0;
  border-radius: 15px;
  box-shadow: 0 8px 15px 0 rgb(0 0 29 / 7%);
  background-color: #fafafa;
  transition: all 250ms ease-out;
  & h2 {
    transition: color 250ms ease-out;
    color: #777;
    margin: 0;
    padding: 0;
  }
  & .description {
    display: grid;
    font-size: 1.2rem;
    position: relative;
    z-index: 2;
    animation-name: ${closeCard};
    animation-duration: 350ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
  }
  &.active {
    ${SliderTitelCon} {
  background-color: #fefefe;
    }
    opacity: 1;
    background-color: #fefefe;
    & h2 {
      color: black;
    }
    & .description {
      animation-name: ${openCard};
      animation-duration: 350ms;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-timing-function: ease-out;
    }
  }
`;

export const ArrowCon = styled.div`
  max-width: 1200px;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  padding-right: 25px;
  column-gap: 40px;
`;

export const SliderArrow = styled(FontAwesomeIcon)`
  font-size: 25px;
  color: black;
  padding: 10px 15px;
  border-radius: 10px;
  transition: all 250ms ease-out;
  &:hover {
    text-shadow: 0 8px 15px 0 rgb(0 0 29 / 7%);
    transform: scale3d(1.1, 1.1, 1);
    cursor: pointer;
  }
  &:active {
    transform: scale3d(0.95, 0.95, 1);
  }
`;
